import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IllustrationVerifiedListingSvg } from "./IllustrationVerifiedListingSvg.mjs";
const IllustrationVerifiedListing = () => /* @__PURE__ */ jsx(Box, { component: IllustrationVerifiedListingSvg });
export {
  IllustrationVerifiedListing
};
